export default function () {
  const autoSubmitElements = document.querySelectorAll("[data-autosubmit]")
  for (let i = 0; i < autoSubmitElements.length; i++) {
    const elem = autoSubmitElements[i]
    elem.addEventListener("change", () => {
      elem.closest("form").submit()
    })
  }
}
